// extracted by mini-css-extract-plugin
module.exports = {"resultsGrid":"Tournaments_resultsGrid__1O_nX"};